import angular from 'angular';

import Component from './clipButton.component';
import './clipButton.component.scss';


export default angular.module('petroCloud.base.clipButton', [])
  .component(Component.name, Component)
  .name;
